import { ScienceProject } from '../types/interfaces'

export default [
  {
    name: 'Física y tecnología de materiales vítreos',
    description:
      'Los materiales vítreos basados en óxidos de silicio y fósforo forman la base de la optoelectrónica moderna. Su estructura única y amorfa permite una amplia modificación de las propiedades fisicoquímicas. Como parte de mi actividad científica, sintetizo vidrios innovadores de silicato y fosfato y estudio de manera integral sus propiedades eléctricas y ópticas, lo cual es crucial para diseñar una nueva generación de fibras ópticas y sensores.',
    time: '2025+',
  },
  {
    name: 'Conductividad iónica en compuestos vitrocerámicos',
    description:
      'Los compuestos vitrocerámicos que exhiben alta conductividad iónica (Li+, Na+, K+, O2-) son un elemento clave de la revolución en el almacenamiento y conversión de energía. Son una alternativa segura a los componentes líquidos en baterías de estado sólido de próxima generación y pilas de combustible. Mi investigación se centra en optimizar el transporte de iones en estas estructuras mediante el análisis de su microestructura y mediciones de impedancia.',
    time: '2025+',
  },
  {
    name: 'Modelado de procesos iónicos',
    description:
      'La aplicación de inteligencia artificial está revolucionando la ingeniería de materiales moderna. El uso de redes neuronales y aprendizaje automático (potenciales de ML) permite simular la dinámica molecular y el transporte de iones en materiales vítreos con precisión cuántica a un costo computacional mínimo. El proyecto implica la implementación de algoritmos de aprendizaje automático para predecir las propiedades estructurales y difusivas de los vidrios.',
    time: '2026+',
  },
  {
    name: 'Aceleradores y aparatos nucleares',
    description:
      'Los aceleradores son dispositivos utilizados para acelerar partículas y emitir radiación. Encuentran muchas aplicaciones en la industria y la investigación científica, donde se utilizan, entre otros, para la implantación de iones o la detección de defectos en materiales. También se utilizan en la radioterapia del cáncer. La construcción de aparatos nucleares implica tanto el uso de la electrónica industrial como el aprendizaje de técnicas como bombas de iones, hornos de vacío y sistemas de refrigeración hidráulica. Durante mis prácticas, aprendí sobre la construcción y las capacidades de los aceleradores y creé software para controlarlos.',
    time: '2025',
    label: {
      text: 'Prácticas',
      color: '#00647D',
    },
  },
  {
    name: 'Conductores superiónicos',
    description:
      'Los conductores superiónicos son materiales que exhiben alta conductividad iónica, lo que los hace prometedores para aplicaciones en baterías y pilas de combustible. Durante unas miniprácticas de verano en el Centro de Materiales y Tecnologías Avanzadas CEZAMAT, produjimos muestras de dichos materiales y luego estudiamos sus propiedades utilizando técnicas como la difracción de rayos X (XRD).',
    time: 'Verano de 2024',
    label: {
      text: 'Proyecto de verano',
      color: '',
    },
  },
  {
    name: 'Vidrio de bismuto',
    description:
      'Durante unas miniprácticas de verano en la Facultad de Física de la Universidad Tecnológica de Varsovia, nos ocupamos de la síntesis del vidrio de bismuto y de aprender sobre las propiedades de los materiales con estructuras cristalinas y amorfas. Luego examinamos sus propiedades eléctricas, térmicas y estructurales, con especial énfasis en las transiciones de fase, que este material experimenta debido a la temperatura, por ejemplo, la cristalización.',
    time: 'Verano de 2024',
    label: {
      text: 'Proyecto de verano',
      color: '',
    },
  },
] as ScienceProject[]
